import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IHostService = ( createDecorator('hostService'));
export { IHostService };
